module.exports = __webpack_public_path__ + "img/calendar2-check-fill.a9c2457c.svg";